export default __webpack_public_path__ + "static/media/ITALIC_pressed.2e7eb9a5.svg";